import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import formMapper from "@mappers/Clients/Hackatao/mainAvatars/MainAvatars.mapper";
import createItem from "@services/Clients/Hackatao/mainAvatars/createItem";
import FormValidator from "@validators/Clients/Hackatao/mainAvatars/MainAvatars.validate";
import CreateForm from "./CreateForm";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItem}
    validator={FormValidator}
    formMapper={formMapper}
  />
);

export default CreateItem;
